import { LoadingBox, LoadingIcon, StyledChatBox } from './Chat.styles'

type ChatboxProps = {
  conversationId: string
}

export function Chatbox({ conversationId }: ChatboxProps) {
  return (
    <StyledChatBox
      conversationId={conversationId}
      loadingComponent={
        <LoadingBox>
          <LoadingIcon data-testid="loading-spinner" />
        </LoadingBox>
      }
      data-testid="chatbox"
    />
  )
}
